import { useState, useEffect, useRef } from 'react';

const useWebSocket = (url) => {
  const [data, setData] = useState([]);

  const [notifications, setNotifications] = useState([]);
  const [count, setCount] = useState(0);
  const ws = useRef(null); // Use useRef to keep the WebSocket instance
  const heartbeatInterval = useRef(null);

  const connectWebSocket = () => {
    ws.current = new WebSocket(url);

    ws.current.onopen = () => {
      console.log('WebSocket connection opened');
      startHeartbeat();
    };

    ws.current.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data.type !== 'heartbeat') {
        const message = data.message;
        setMessage(data);
      }
    };

    ws.current.onclose = () => {
      console.error('WebSocket connection closed unexpectedly. Reconnecting in 5 seconds...');
      clearInterval(heartbeatInterval.current);
      setTimeout(connectWebSocket, 5000); // Attempt to reconnect after 5 seconds
    };
    ws.current.onerror = (e) => {
      console.error('WebSocket error:', e);
      ws.current.close(); // Close the connection on error to trigger reconnection
    };
  };

  const startHeartbeat = () => {
    heartbeatInterval.current = setInterval(() => {
      if (ws.current.readyState === WebSocket.OPEN) {
        ws.current.send(JSON.stringify({ type: 'heartbeat' }));
      }
    }, 30000); // Send a heartbeat every 30 seconds
  };

  const setMessage = (data) => {
    setNotifications((prevNotifications) => [...prevNotifications, data.message]);
    setCount((prevCount) => prevCount + 1);
    setData((prevData)=>[...prevData, data])
  };

  useEffect(() => {
    connectWebSocket();
    return () => {
      clearInterval(heartbeatInterval.current);
      if (ws.current) {
        ws.current.close(); // Clean up WebSocket connection on component unmount
      }
    };
  }, []);

  const sendNotification = (action,message,id=null) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      // ws.current.send(JSON.stringify({ type: 'new_notification', message })); 
      //ws.current.send(JSON.stringify({ type: action, message, id:id }));
      ws.current.send(JSON.stringify({"action": "sendAllTransaction", "message": message}));
 
      //{"action": "sendTransaction", "message": "2024_0000001", "user_id" : "1a104ff07117f9abfe02"}
      
    }
  };

  return {
    notifications,
    count,
    sendNotification,
    data
  };
};

export default useWebSocket;
